module.exports = __webpack_public_path__ + "media/images/redrock/checkmark-41336b91f8880b8fb4ad95ec6c852120.png";